import script from "./LayersMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./LayersMenu.vue?vue&type=script&setup=true&lang=ts"

import "./LayersMenu.vue?vue&type=style&index=0&id=2df7226e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2df7226e"]])

export default __exports__